import { Header } from "./Header";
import { Navigation } from "./Navigation";

interface MainLayoutProps {
  children: React.ReactNode;
}

export function MainLayout({ children }: MainLayoutProps) {
  return (
    <div className="min-h-screen bg-background">
      <Header />
      <Navigation />
      <main className="container py-6">
        {children}
      </main>
    </div>
  );
}
